import React, { useState,useEffect } from "react";
import UserManagementTable from "./UserManagementTable";
import {
  getUserTypeList
} from "../../services/user-type.services";
const UserManagement = () => {


  return <div>{<UserManagementTable />}</div>;
};

export default UserManagement;
